/** Supabase V1 refresh tokens are 12 alphanumeric chars; V2 are v1.* or long. */
export function isValidRefreshToken(token) {
  if (!token || typeof token !== 'string') return false;
  if (token === 'refreshToken' || token === 'refresh_token') return false;
  if (token.length === 12 && /^[A-Za-z0-9]+$/.test(token)) return true;
  if (token.startsWith('v1.') && token.length >= 10) return true;
  return token.length >= 20;
}
